import { Component, OnInit, Input, Output, EventEmitter, ContentChildren, forwardRef, QueryList } from '@angular/core';
import { TableFilter } from './table.filters.interface';
import { TableAction } from "./table.action";
import { TableActionComponent } from "app/components/common/table/table-action/table-action.component";
import { Observable } from "rxjs/Observable";
import { Transform } from 'app/components/common/table/transform';
import { TableHeaderComponent } from 'app/components/common/table/table-header/table-header.component';
import {TableSelect} from "./table-select";
import {TableStatic} from "./table-static";

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})


export class TableComponent implements OnInit {

  //Um array de qualquer objeto.
  //Esses objetos serão usados como Data Source da tabela.
  @Input('source')
  source: Array<any>;

  //Uma flag que indica se haverá paginação ou não
  @Input()
  pagination: boolean = false;

  //Um input que determina o número de registro por página que o usuário pode selecionar.
  @Input('rows-options')
  protected rowsOptions: Array<number>;

  //Determina a quantidade total de registros que serão exibidos na tabela.
  @Input('count')
  protected count?: number;

  //Método que é executado ao mudar a página
  @Input('onPageChanging')
  protected onPageChanging: (page: number, rowsPerPage: number) => void;

  //Método que é executado ao clicar em uma linha da tabela
  @Input("rowAction")
  protected  rowAction: (obj) => void;

  //Boolean que indica se a tabela está carregando dados ou não.
  @Input()
  loading: boolean = false;

  @Input('full-search')
  hasFullSearch: boolean = false;

  @Input("check")
  hasCheck: boolean = false;

  @Output("checked")
  public checkedOutput: EventEmitter<Array<any>>;

  @Output("onOptionSelected")
  public optionSelect: EventEmitter<any>;

  //Output de notificação de modificação de filtros
  @Output('onFilterChanged')
  protected filterChanged: EventEmitter<any>;

  //A lista de transformação de string.
  //É responsável por aplicar as transformações (formatações) do conteúdo da célula
  protected transforms: Array<Transform>;

  protected checkedRows: Map<number, any> = new Map<number, any>();

  /**
   * Referência para os headers da tabela. 
   */
  @ContentChildren(forwardRef(() => TableHeaderComponent)) headerComponents: QueryList<TableHeaderComponent>;

  /**
   * Referência para o componente TableHeaderComponent que está sendo ordenado no momento
   */
  private currentOrdered: TableHeaderComponent;

  /**
   * Define a ordenação padrão da tabela considerando a primeira coluna.
   */
  setDefaultOrder(): void {
    const property: string = this.headerComponents.first.getProperty();
    this.orderBy(property, true);
  }
  
  /**
   * Define qual coluna da tabela está sendo ordenada atualmente.
   * @param thc componente TableHeaderComponent que será ordenado
   */
  setCurrentOrdered(thc: TableHeaderComponent): void {
    this.currentOrdered = this.currentOrdered === undefined ? thc : this.currentOrdered;

    if(this.currentOrdered.getProperty() !== thc.getProperty()) {
      this.currentOrdered.setIsAsc(null);
      this.currentOrdered = thc;
    }
  }

  protected rowsPerPage: number;
  protected properties: Array<string>;
  protected statics: Array<TableStatic>;
  protected pages: Array<Array<any>>;
  protected itensCount: number;
  protected currentPage: number = 1;
  protected filters: Array<TableFilter>
  protected generalSearch: string = "";
  actions: Array<TableAction> = [];
  selects: Array<TableSelect> = [];

  constructor() {
    this.properties = new Array<string>();
    this.statics = new Array<TableStatic>();
    this.filters = new Array<TableFilter>();
    this.actions = new Array<TableAction>();
    this.filterChanged = new EventEmitter<any>();
    this.checkedOutput = new EventEmitter<any>();
    this.optionSelect = new EventEmitter<any>();
    this.transforms = new Array<Transform>();
  }

  public ngOnInit(): void {
    if(this.pagination)
      this.rowsPerPage = this.rowsOptions[0];
    else{
      this.rowsPerPage = this.source.length;
    }
    this.update();
  }

  protected paginate(): Array<Array<any>>{
    if(this.pagination && this.source != undefined){
      var pageQuantity = Math.ceil(this.source.length / this.rowsPerPage);
      var pages = new Array<Array<any>>();
      var filtered = this.filter();

      for(var page = 0; page < pageQuantity; page++){
        pages.push(filtered.slice(page * this.rowsPerPage, (page + 1) * this.rowsPerPage));
      }

      return pages;
    }
    else {
      let pages = Array<Array<any>>();
      pages.push(this.source);
      return pages;
    }
  }

  public update(): void{
    this.pages = this.paginate();
  }

  /**
   * Realiza a busca do valor de uma propriedade qualquer em um objeto
   * @param obj Objeto em que a busca será realizada
   * @param path Propriedade desejada
   */
  public searchInNestedObject(obj, path) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  protected filter(): Array<any>{
    var filtered = this.fullSearch();
    for(let filter of this.filters){
      filtered = filtered.filter(x => {
        try {
          let propertyValue = this.searchInNestedObject(x, filter.property).toLowerCase();
          let searchArg = filter.value.toString().toLowerCase();
          let index = propertyValue.indexOf(searchArg);

          if(index != -1) return x;
        } catch(e) {
          console.log("Error in search property in object");
        }
      });
    }

    this.itensCount = filtered.length;
    return filtered;
  }

  protected pageChanged(event: any) {
    this.currentPage = event.page;
  }

  getCurrentPage(): Array<any> {
    this.update();
    return this.pages[this.currentPage - 1];
  }

  public addProperties(property: string): void {
    this.properties.push(property);
  }

  public addStatics(staticColumn: TableStatic): void {
    this.statics.push(staticColumn);
  }

  public search(tableFilter: TableFilter){
    if (tableFilter.value == ''){
      let index = this.filters.findIndex(x => x.property == tableFilter.property);
      if (index >= 0)
        this.filters.splice(index, 1);
    }
    else {
      var property = this.filters.find(x => x.property == tableFilter.property);
      if(property != null){
        property.value = tableFilter.value;
      } else {
        this.filters.push(tableFilter);
      }
    }
    this.update();
  }

  public orderBy(property: string, isAsc: boolean): void{
    var orderByAscending = function(a, b){
      const s1 = a[property].toLowerCase();
      const s2 = b[property].toLowerCase();
      if (s1 < s2)
        return -1;
      if (s1 > s2)
        return 1;
      return 0;
    }

    var orderByDescending = function(a, b){
      const s1 = a[property].toLowerCase();
      const s2 = b[property].toLowerCase();
      if (s1 > s2)
        return -1;
      if (s1 < s2)
        return 1;
      return 0;
    }
    this.filterChanged.emit({property: property, isAsc: (isAsc ? 0 : 1)})
    this.source.sort((isAsc ? orderByAscending : orderByDescending));
    this.update();
  }

  protected pageChanging(): void{
    this.onPageChanging(this.currentPage, this.rowsPerPage);
  }

  public addAction(tableAction: TableAction){
    this.actions.push(tableAction);
  }

  public addTransform(transform: Transform){
    this.transforms.push(transform);
  }

  public getSelectedObject(selectedIndex: number): any{
    return this.pages[this.currentPage - 1][selectedIndex];
  }

  public fullSearch(): Array<any>{
    let elems = this.source.slice();
    var result = [];


    for(let elem of elems){
      for(let property of this.properties){
        if(String(elem[property]).toLowerCase().indexOf(this.generalSearch) != -1){
          result.push(elem);
          break;
        }
      }
    }

    return result;
  }

  protected getProperty(item: any, property: string): any{
    var properties = property.split('.');
    var result = item;
    for(var prop of properties){
      result = result[prop];
      if (result == null) {
        return null;
      }
    }
    return result;
  }


  protected checkConditional(item, conditional: (obj: any) => boolean){
    if(conditional == undefined || conditional == null){
      return true;
    }
    else{
        return conditional(item);
    }
  }

  protected setFullSearch(search: string): void{
    this.generalSearch = search;
    this.update();
  }


  protected render(item: any, property: string): string{
    let data = this.getProperty(item, property);
    if(this.transforms.some(x => x.property == property)){
      let transformFn = this.transforms.find(x => x.property == property).transform;
      return transformFn(data);
    }
    return String((data == null || data == undefined) ? "" : data);
  }

    isProgressBar(property: string) {
        return property === "progressBar";
    }

    progress(property) {
      let myStyles = {
          width: property+"%"
      }
        return myStyles
    }

  check(index: any) {
    let key = this.currentPage*(index+1);
    if(this.checkedRows.get(key))
      this.checkedRows.delete(key);
    else
      this.checkedRows.set(key, this.getSelectedObject(index));

    this.checkedOutput.emit(Array.from(this.checkedRows.values()));
  }

  isChecked(index) {
    let key = this.currentPage*(index+1);
    return this.checkedRows.get(key) != undefined;
  }

  addSelect(param: TableSelect) {
      this.selects.push(param);
  }

  saveOptionSelect($event, index) {
      this.optionSelect.emit({
          data: this.getSelectedObject(index),
          checked: this.hasCheck && this.isChecked(index),
          option: $event.target.value,
          element: $event.target,
          name: $event.target.getAttribute('name')
      });
  }

  isStatus(property: string) {
    return property === "status";
  }

  //TODO: usar um recurso html ou css para fazer isso na tabela
  truncate(value)  {
      if(value) return (value.length > 60) ? '...' + value.substr(value.length-60, value.length) : value;
      else return undefined;
  }
}
